import {useEffect} from 'react'
import {Outlet, useLocation, useNavigate} from 'react-router-dom'
import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/scroll-top'
import {Content} from './components/content'
import {Sidebar} from './components/sidebar'
import {
  DrawerMessenger,
  ActivityDrawer,
  // InviteUsers,
  // UpgradePlan,
  ThemeModeProvider,
} from '../partials'
import {PageDataProvider} from './core'
import {reInitMenu} from '../helpers'

const MasterLayout = () => {
  const location = useLocation()
  const navigate = useNavigate()

  // Handle sidebar/menu re-init on route change
  useEffect(() => {
    reInitMenu()
    
    // After a short delay, ensure proper menu state
    setTimeout(() => {
      // First, close all submenus
      const allSubmenus = document.querySelectorAll('.menu-sub')
      allSubmenus.forEach(submenu => {
        submenu.setAttribute('style', 'display: none; overflow: hidden;')
      })

      // Then, find and open the active menu
      const activeMenuItems = document.querySelectorAll('.menu-item .menu-link.active')
      activeMenuItems.forEach(activeLink => {
        const menuItem = activeLink.closest('.menu-item')
        if (menuItem) {
          // Find the parent menu item with submenu
          const parentMenuItem = menuItem.closest('.menu-sub')?.closest('.menu-item')
          if (parentMenuItem) {
            // Find the submenu and make it visible
            const submenu = parentMenuItem.querySelector('.menu-sub')
            if (submenu) {
              submenu.removeAttribute('style')
              submenu.setAttribute('style', 'display: block !important;')
            }
          }
        }
      })
    }, 100)
  }, [location.pathname])

  // Keyboard Shortcut Logic
  // useEffect(() => {
  //   const handleKeyDown = (e: KeyboardEvent) => {
  //     if ( (e.altKey && e.key.toLowerCase() === 'v')) {
  //       e.preventDefault()
  //       navigate('/party-entry/auto-vatav') // Replace with your actual route if different
  //     }

  //     // if ( e.key.toLowerCase() === 'n') {
  //     //   e.preventDefault()
  //     //   navigate('/party-entry/normal-entry') // Your NormalEntry route
  //     // }
  //   }
  //   window.addEventListener('keydown', handleKeyDown)
  //   return () => window.removeEventListener('keydown', handleKeyDown)
  // }, [navigate])

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='' id='kt_app_root'>
          <div className='' id='kt_app_page'>
            {/* <HeaderWrapper /> */}
            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
              <Sidebar />
              <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                <div className='d-flex flex-column flex-column-fluid'>
                  {/* <ToolbarWrapper /> */}
                  <Content>
                    <Outlet />
                  </Content>
                </div>
                {/* <FooterWrapper /> */}
              </div>
            </div>
          </div>
        </div>

        {/* begin:: Drawers */}
        <ActivityDrawer />
        <RightToolbar />
        <DrawerMessenger />
        {/* end:: Drawers */}

        {/* begin:: Modals */}
        {/* <InviteUsers /> */}
        {/* <UpgradePlan /> */}
        {/* end:: Modals */}
        <ScrollTop />
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export {MasterLayout}
